import type { DocumentData, DocumentReference } from 'firebase/firestore'
import { Timestamp } from 'firebase/firestore'

export interface ChangeLogEntry {
  fieldChanged: string
  oldValue: string
  newValue: string
}

export class ChangeLogModel {
  date: Timestamp | string | null
  documentDate: Timestamp | string | null
  userChanged: DocumentReference | null
  userName: string
  collectionChanged: DocumentReference | null
  changes: ChangeLogEntry[]
  city: string
  name: string
  route: DocumentReference | null
  company: DocumentReference | null
  isNewDocument: boolean

  constructor(data: Partial<ChangeLogModel>) {
    this.date = data.date || new Timestamp(Math.floor(new Date().getTime() / 1000), 0)
    this.documentDate = data.documentDate || null
    this.userChanged = data.userChanged || null
    this.userName = data.userName || ''
    this.collectionChanged = data.collectionChanged || null
    this.changes = data.changes || []
    this.city = data.city || ''
    this.name = data.name || ''
    this.route = data.route || null
    this.company = data.company || null
    this.isNewDocument = data.isNewDocument || false
  }

  toMap() {
    return {
      date: this.date,
      documentDate: this.documentDate,
      userChanged: this.userChanged,
      userName: this.userName,
      collectionChanged: this.collectionChanged,
      changes: this.changes,
      city: this.city,
      name: this.name,
      route: this.route,
      company: this.company,
      isNewDocument: this.isNewDocument,
    }
  }
}

export function mapDataChangeLog(data: DocumentData) {
  return new ChangeLogModel(data.data())
}
